<template>
  <div>
    <div class="dropdown-container position-relative">
      <i class="bi bi-calendar4 position-absolute dropdown-icon-left"></i>
      <select class="form-select form-select-sm dropdown-with-icon-left" v-model="localSelectedDuration" @change="handleSelection">
        <option :value="1" :disabled="disabledDurations.includes('1')">{{ $t('controls.duration.yesterday') }}</option>
        <option :value="7" :disabled="disabledDurations.includes('7')">{{ $t('controls.duration.last7') }}</option>
        <option :value="30" :disabled="disabledDurations.includes('30')">{{ $t('controls.duration.last30') }}</option>
        <option :value="90" :disabled="disabledDurations.includes('90')">{{ $t('controls.duration.last90') }}</option>
        <option :value="365" :disabled="disabledDurations.includes('365')">{{ $t('controls.duration.last365') }}</option>
        <option :value="1000" :disabled="disabledDurations.includes('1000')">{{ $t('controls.duration.thisWeek') }}</option>
        <option :value="2000" :disabled="disabledDurations.includes('2000')">{{ $t('controls.duration.thisMonth') }}</option>
        <option :value="3000" :disabled="disabledDurations.includes('3000')">{{ $t('controls.duration.lastWeek') }}</option>
        <option :value="4000" :disabled="disabledDurations.includes('4000')">{{ $t('controls.duration.lastMonth') }}</option>
      </select>
    </div>
  </div>
</template>

<script>
import { ref, watch, toRefs } from 'vue';

export default {
  name: 'DurationDropdown',

  props: {
    dateRangeMode: String,
    selectedDuration: {
      type: Number,
      default: 30, // Default to "Last 30 Days"
    },
    disabledDurations: {
      type: Array,
      default: () => [],
    }
  },

  emits: ['updateDateRangeMode', 'updateDuration', 'clearDatePicker'],

  setup(props, { emit }) {
    const localSelectedDuration = ref(props.selectedDuration);
    const { dateRangeMode } = toRefs(props);

    const handleSelection = () => {
      emit('updateDateRangeMode', 'duration');
      emit('updateDuration', localSelectedDuration.value);
      emit('clearDatePicker', true);
    };

    watch(dateRangeMode, (newMode) => {
      if (newMode === 'dateRange') {
        localSelectedDuration.value = null; // Allow user to select any value
      }
    });

    return {
      localSelectedDuration,
      dateRangeMode,
      handleSelection,
    };
  },
};
</script>

<style scoped>
.dropdown-container {
  position: relative;
  width: 160px; /* Adjust width as needed */
  max-width: 100%; /* never exceed the (possibly narrow) container */
}

.form-select {
  color: #4F7EB3;
  padding: 5px 10px;
  border-radius: 4px;
}

.dropdown-with-icon-left {
  padding-left: 2.5rem; /* Add padding to make room for the icon */
}

.dropdown-icon-left {
  left: 10px; /* Position icon inside the select box on the left */
  top: 50%; /* Center vertically */
  transform: translateY(-50%);
  pointer-events: none; /* Prevent interaction with the icon */
  color: #425461; /* Adjust color if needed */
  font-size: 1rem; /* Adjust size if needed */
}
</style>